import { EManifestStatus } from '../../types/chatbotFiltersModal';
import { IMicrofrontendManifest } from '../../types/microfrontendManifest';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatbotFiltersModalActionTypes {
  Open = 'chatbotFiltersModal/show',
  Close = 'chatbotFiltersModal/hide',
  SetManifest = 'chatbotFiltersModal/setManifest',
  SetManifestStatus = 'chatbotFiltersModal/setManifestStatus',
  SetFiltersLoading = 'chatbotFiltersModal/SetFiltersLoading',
}

export type TChatbotFiltersModalSetManifestPayload = {
  manifest: IMicrofrontendManifest;
};

export type TChatbotFiltersModalActions =
  | ITypedReduxAction<EChatbotFiltersModalActionTypes.Open, void>
  | ITypedReduxAction<EChatbotFiltersModalActionTypes.SetManifest, TChatbotFiltersModalSetManifestPayload>
  | ITypedReduxAction<EChatbotFiltersModalActionTypes.SetManifestStatus, EManifestStatus>
  | ITypedReduxAction<EChatbotFiltersModalActionTypes.SetFiltersLoading, boolean>
  | ITypedReduxAction<EChatbotFiltersModalActionTypes.Close, void>;
